export default class FormHandler {
     init() {
        Array.prototype.forEach.call(document.querySelectorAll('.form'), el => {
            new FormHandler(el);
        });
    }

    constructor(element) {
        if (!element) return;
        this.element = element;

        this.element.addEventListener('submit', (e) => {
            this.submitHandler(e);
        });

        this.fileInputsHandler();
    }

    submitHandler(e) {
         let buttons = this.element.querySelectorAll('input[type="submit"], button[type="submit"]');
        Array.from(buttons).forEach(function(button) {
            button.setAttribute('disabled', 'disabled');
        });
    }

    fileInputsHandler() {
        let input = this.element.querySelector('[type="file"]');

        if (!input) return;

        let wrapper = input.parentNode;
        let addButton = document.querySelector('.add-button');

        if (!addButton) return;

        addButton.addEventListener('click', (e) => {
            e.preventDefault();
            let removeButton = document.createElement('button');
            removeButton.classList.add('remove-button');
            removeButton.setAttribute('title', wrapper.parentNode.dataset.btnRemoveLabel);
            removeButton.setAttribute('aria-labelledby', wrapper.parentNode.dataset.btnRemoveLabel);
            let clone = wrapper.cloneNode(true);
            clone.querySelector('[type="file"]').value = '';

            clone.appendChild(removeButton);
            removeButton.addEventListener('click', (e) => {
                e.preventDefault();
                clone.remove();
            });
            wrapper.parentNode.insertBefore(clone, addButton);
        });
    }
}
